import { toast } from "react-toastify";
import { loadingModel } from "./CommonActions";
import { GET_ARTISTS, GET_ARTIST_BY_ID } from "./ActionTypes";
import { getArtistsApi, getArtistByIdApi } from "../../services/ArtistsServices";

// export function confirmedDeletePostAction(postId) {
//   return {
//     type: CONFIRMED_DELETE_POST_ACTION,
//     payload: postId,
//   };
// }

export function getArtists({ page = 1, search = "", limit = 10 }) {
  return (dispatch, getState) => {
    dispatch(loadingModel(true, GET_ARTISTS));
    getArtistsApi({ page, search, limit }).then((response) => {
      // let posts = formatPosts(response.data);
      dispatch(loadingModel(false, GET_ARTISTS));
      dispatch(confirmedGetArtistsAction(response?.data?.data));
    });
  };
}

export function confirmedGetArtistsAction(data) {
  return {
    type: GET_ARTISTS,
    payload: data,
  };
}

export function getArtistById(id) {
  return (dispatch) => {
    dispatch(loadingModel(true, GET_ARTIST_BY_ID));
    getArtistByIdApi(id).then((response) => {
      dispatch(loadingModel(false, GET_ARTIST_BY_ID));
      dispatch(confirmedGetArtistByIdAction(response?.data?.data));
    });
  };
}

export function confirmedGetArtistByIdAction(data) {
  return {
    type: GET_ARTIST_BY_ID,
    payload: data,
  };
}

// export function loadingModel(loading) {
//   return {
//     type: "LOADING",
//     loading,
//   };
// }
